export const PATH_SEPARATOR = '/';

/**
 * Joins given components of a URL with a slash,
 * ignoring/skipping empty components
 * @param components
 * @returns {string}
 */
export function combinePaths(...components) {
  const hasLeadingSlash = components[0]?.startsWith(PATH_SEPARATOR);
  const componentsWithoutSlashes = components
    .filter(Boolean)
    .map((component) => component.replace(/^\//, ''))
    .filter(Boolean);

  return `${
    hasLeadingSlash ? PATH_SEPARATOR : ''
  }${componentsWithoutSlashes.join(PATH_SEPARATOR)}`;
}
